import { render, staticRenderFns } from "./Horns.vue?vue&type=template&id=e85d3218&scoped=true&"
import script from "./Horns.vue?vue&type=script&lang=js&"
export * from "./Horns.vue?vue&type=script&lang=js&"
import style0 from "./Horns.vue?vue&type=style&index=0&id=e85d3218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85d3218",
  null
  
)

export default component.exports